import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { ChatProvider } from './hooks/useChatContext';
import useAuth from './hooks/useAuth';
import SplashPage from './pages/Splash';
import AuthPage from './pages/Auth';
import ChatPage from './pages/Chat';
import ActionsPage from './pages/Actions';
import SettingsPage from './pages/Settings';
import OnboardPage from './pages/Onboard';
import ProfilePage from './pages/Profile';
import HowItWorksPage from './pages/HowItWorks';
import './styles/variables.css';
import './App.css';

const API_BASE = (process.env.REACT_APP_API_URL || "https://ukd45lve3kvj45tahklem6d67q0fbbxm.lambda-url.us-west-2.on.aws/api/chat").replace('/api/chat', '');

function getVisitorId() {
    let id = localStorage.getItem("intension_visitor_id");
    if (!id) {
        id = crypto.randomUUID?.() || (Date.now() + "-" + Math.random().toString(36).slice(2));
        localStorage.setItem("intension_visitor_id", id);
    }
    return id;
}

function pingSession() {
    const visitorId = getVisitorId();
    const params = new URLSearchParams(window.location.search);
    const source = params.get("utm_source") || params.get("utm_campaign") || "";
    const referrer = document.referrer || "";

    fetch(`${API_BASE}/api/ping`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            visitor_id: visitorId,
            source,
            referrer,
        }),
    }).then(res => res.json()).then(data => {
        if (data.visitor_id) {
            localStorage.setItem("intension_visitor_id", data.visitor_id);
        }
    }).catch(() => {});
}

function AppRoutes() {
    const auth = useAuth();

    useEffect(() => {
        pingSession();
    }, []);

    if (auth?.loading) {
        return <div className="app-loading" />;
    }

    const isAuthed = !!auth?.user;

    return (
        <Routes>
            <Route path="/" element={isAuthed ? <ChatPage /> : <SplashPage />} />
            <Route path="/auth" element={isAuthed ? <Navigate to="/" /> : <AuthPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/actions" element={isAuthed ? <ActionsPage /> : <Navigate to="/auth" />} />
            <Route path="/settings" element={isAuthed ? <SettingsPage /> : <Navigate to="/auth" />} />
            <Route path="/onboard" element={isAuthed ? <OnboardPage /> : <Navigate to="/auth" />} />
            <Route path="/profile" element={isAuthed ? <ProfilePage /> : <Navigate to="/auth" />} />
        </Routes>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <ChatProvider>
                    <AppRoutes />
                </ChatProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}
